import { render } from "./Forbidden.vue?vue&type=template&id=7bd031cd&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"

import "./Forbidden.vue?vue&type=style&index=0&id=7bd031cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd031cd"]])

export default __exports__